const LegendLayout = {
    DETAILED: 'detailed',
    SIMPLIFIED: 'simplified',
};

export default LegendLayout;
